
import Vue, { PropType } from "vue"
import { Filter } from "./ListParagon.vue";
import DateFormatMixin from "@/mixins/DateFormatMixin.vue";
import { VueConstructor } from "vue/types/umd";

export default (Vue as VueConstructor<Vue & InstanceType<typeof DateFormatMixin>>).extend({
  mixins: [DateFormatMixin],
  name: "FilterWithPeriod",
  props: {
    filtersData: {
      type: Object as PropType<Filter>,
      required: true
    }
  },
  data() {
    return {
      filterValues: {} as {[key: string]: string[]},
      fromToDate: {} as {[key: string]: string},
      internalModalOpen: false,
      periods: [] as string[],
      selectedFilters: {} as {[key: string]: string|string[]},
      localDateValue: [] as string[],
      from: null as 'before'|'after'|null,
      selectionFilter: false
    }
  },
  computed: {
    hasSelectedFilters() {
      return Object.keys(this.selectedFilters).length > 0
    },
    hasValidFilters() {
      for (const [, value] of Object.entries(this.selectedFilters)) {
        if (value !== undefined && value !== null && value !== '') {
          if (Array.isArray(value)) {
            if (value.length > 0) {
              return true
            }
          } else {
            return true
          }
        }
      }
      return false
    },
    titleReturn() {
      let title = this.$vuetify.lang.t('$vuetify.no_date_selected')
      if (this.localDateValue && this.localDateValue.length > 1) {
        title = this.$vuetify.lang.t(`$vuetify.from`) + ' ' + this.simplifyLocalizeDate(this.localDateValue[0],false) + ' ' + this.$vuetify.lang.t(`$vuetify.to`) + ' ' + this.simplifyLocalizeDate(this.localDateValue[1],false)
      } else if (this.localDateValue && this.localDateValue.length === 1 && this.from === 'before') {
        title = this.$vuetify.lang.t(`$vuetify.to`) + ' ' + this.simplifyLocalizeDate(this.localDateValue[0],false)
      } else if (this.localDateValue && this.localDateValue.length === 1 && this.from === 'after') {
        title = this.$vuetify.lang.t(`$vuetify.from`) + ' ' + this.simplifyLocalizeDate(this.localDateValue[0],false)
      }
      return title
    }
  },
  watch: {
    internalModalOpen(newVal: boolean) {
      // Emit the event to the parent component to force open navigation drawer for filter
      this.$emit('openModalFilterWithMethod', newVal)
    }
  },
  methods: {
    getCheckboxValue(filter: Filter): string | string[] {
      if (filter.onlyDate) {
        return this.periods
      }
      if (filter.value) {
        return filter.value as string
      }
      return "true"
    },
    isCheckboxChecked(filter: Filter): boolean {
      return this.selectedFilters[filter.label] !== undefined
    },
    handleCheckboxChange(event: boolean, filter: Filter) {
      const value = this.getCheckboxValue(filter)
      
      if (event === false) {
        this.$delete(this.selectedFilters, filter.label)
      } else {
        this.$set(this.selectedFilters, filter.label, value)
      }
    },
    cancelFilterForModal() {
      this.selectedFilters = {} as {[key: string]: string}
      this.periods = [] as string[]
      this.localDateValue = []
      this.internalModalOpen = false;
      this.selectionFilter = false
    },
    definePeriod() {
      this.filterValues[this.filtersData.label] = [...this.localDateValue]
      this.periods = [...this.localDateValue]
      this.selectionFilter = true
    },
    sendSearch() {
      this.internalModalOpen = false
      if (this.periods.length > 1) {
        this.from = null
      }
      const filters = {...this.selectedFilters, 'periods': this.periods, 'from': this.from}
      this.$emit('sendSearch', filters)
      this.cancelFilterForModal()
    },
    backToPeriod() {
      this.selectionFilter = false
    },
  }
})
